/**
 * Tārā Bala by number (B-139-REQ). The endpoint now takes `nakshatra_number`; the
 * day context it used to read out of the posted sentence (when the first nakṣatra
 * ends, which one follows, and when that one ends) comes from the panchanga's own
 * `angas`, through the same row rules as the Daily Pañcāṅga card, so the Tārā Bala
 * card receives exactly the object it received before.
 */
import type { components } from '../../types/api.gen';
import type { TaraBalamResponse } from '../../types/api';
import { angaRows, AngaRow } from '../PanchangaCard/angaRows';

type AngaSegment = components['schemas']['AngaSegment'];

export interface NakshatraDay {
  first: AngaRow;
  second: AngaRow | null;
}

export const nakshatraDay = (segments: AngaSegment[], day: string): NakshatraDay | null => {
  const rows = angaRows(segments, 'nakshatra', day);
  return rows.length ? { first: rows[0], second: rows[1] ?? null } : null;
};

export const withDayContext = (response: TaraBalamResponse, day: NakshatraDay): TaraBalamResponse => ({
  ...response,
  first_nakshatra_end_time: day.first.time,
  second_nakshatra_number: day.second?.number ?? null,
  second_nakshatra_name: day.second?.nameEn ?? null,
  second_nakshatra_end_time: day.second?.time ?? null,
});
